export default __webpack_public_path__ + "static/media/etc08.3769e935.png";